// Utils
import cn from '../../../../utils/cn';

// Styles
import styles from './DirectEditLoadingCell.module.css';
import directEditCommon from '../DirectEditCommon.module.css';

// Table cell layout
import { getDirectEditShellProps } from '../getDirectEditShellClassName';

/**
 * Pending-save state for a direct-edit table cell: keeps the current value visible with a gray overlay.
 * @param {object} props
 * @param {TableCellValueObjectCustom} props.cellValue - Cell value (for shell alignment)
 * @param {React.ReactNode} props.children - Read-mode cell content to keep visible while saving
 * @returns {JSX.Element}
 */
function DirectEditLoadingCell({ cellValue, children }) {
  const { className: shellClassName, style: shellStyle } = getDirectEditShellProps(cellValue);

  return (
    <div
      className={cn([shellClassName, styles['direct-edit-loading-shell']])}
      style={shellStyle}
      aria-busy="true"
      aria-live="polite"
    >
      <span className={directEditCommon['direct-edit-value-slot']}>
        {children}
      </span>
      <div className={styles['direct-edit-loading-overlay']} aria-hidden />
    </div>
  );
}

export default DirectEditLoadingCell;
